<template>
  <div class="navbar">
    <hamburger class="hamburger-container" />
    <div class="navbar-left">
      <breadcrumb id="guide-breadcrumb" class="breadcrumb-container" />
      <span class="navbar-title">运营后台</span>
    </div>

    <div class="right-menu">
      <!-- 头像 -->
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <el-avatar
            shape="square"
            :size="40"
            :src="'https://res.lgdsunday.club/my-avatar.jpg'"
          ></el-avatar>
          <span class="avatar-meta">
            <span class="avatar-name">Admin</span>
            <span class="avatar-role">管理员</span>
          </span>
          <el-icon class="avatar-arrow"><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu class="user-dropdown">
            <router-link to="/">
              <el-dropdown-item>
                <el-icon><House /></el-icon>
                {{ '首页' }}
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item divided @click="logout">
              <el-icon><SwitchButton /></el-icon>
              {{ '退出登录' }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import Hamburger from '@/components/Hamburger'
import Breadcrumb from '@/components/Breadcrumb'
import { useStore } from 'vuex'
import { ArrowDown, House, SwitchButton } from '@element-plus/icons-vue'

const store = useStore()
const logout = () => {
  store.dispatch('user/logout')
}
</script>

<style lang="scss" scoped>
.navbar {
  height: var(--admin-header-height);
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  background: transparent;
  box-shadow: none;

  .hamburger-container {
    line-height: var(--admin-header-height);
    height: 100%;
    flex: 0 0 auto;
    cursor: pointer;
    transition: background 0.18s ease;

    &:hover {
      background: rgba(15, 23, 42, 0.04);
    }
  }

  .navbar-left {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  .navbar-title {
    padding-left: 12px;
    border-left: 1px solid var(--admin-color-border);
    color: var(--admin-color-text-muted);
    font-size: 13px;
    line-height: 18px;
  }

  .right-menu {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    padding-right: 16px;

    ::v-deep .right-menu-item {
      display: inline-block;
      padding: 0 18px 0 0;
      font-size: 24px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    ::v-deep .avatar-container {
      cursor: pointer;
      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        min-height: 40px;
        padding: 4px 8px 4px 4px;
        border-radius: 8px;
        transition: background 0.18s ease;

        &:hover {
          background: #f8fafc;
        }

        .el-avatar {
          flex-shrink: 0;
          --el-avatar-background-color: #e5e7eb;
          border-radius: 8px;
        }

        .avatar-meta {
          display: flex;
          flex-direction: column;
          gap: 1px;
          line-height: 1;
        }

        .avatar-name {
          color: var(--admin-color-text);
          font-size: 13px;
          font-weight: 600;
        }

        .avatar-role {
          color: var(--admin-color-text-muted);
          font-size: 11px;
          line-height: 14px;
        }

        .avatar-arrow {
          color: var(--admin-color-text-muted);
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .navbar {
    .navbar-title,
    .avatar-meta {
      display: none;
    }
  }
}
</style>
